// Check if we're on a collections page
if (window.location.pathname.indexOf("collections")) {
  // Remove featured-product class on pages after 1
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const currentPage = urlParams.get("page");

  if (currentPage && currentPage !== "1") {
    const productGridElm = document.getElementById(
      "main-collection-product-grid"
    );
    const featuredProductElms =
      productGridElm.querySelectorAll(".featured-product");
    featuredProductElms.forEach((elm) =>
      elm.classList.remove("featured-product")
    );
  }
}
